export const COORDS_FALLBACK = {
    'city': 'Geneva',
    'lat': '6.1459',
    'lon': '46.2054'
};

export default class CoordsSession {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        this.getCoordsByIp();
    }

    /**
     * Method to get coords by Ip
     */
    getCoordsByIp() {
        let coords = {};
        coords.city = document.querySelector('body').getAttribute('data-city');
        coords.lat = document.querySelector('body').getAttribute('data-lat');
        coords.lon = document.querySelector('body').getAttribute('data-lon');

        if(coords) {
            this.setCoordsInSession(coords);
        } else {
            this.setCoordsInSession(COORDS_FALLBACK);
        }
    }

    /**
     * Setter
     * @param coords
     */
    setCoordsInSession(coords) {
        sessionStorage.setItem('coords', JSON.stringify(coords));
    }

    /**
     * Getter
     * @returns {any}
     */
    getCoordsFromSession() {
        return JSON.parse(sessionStorage.getItem('coords'));
    }
}
